import styled from "styled-components";

import { theme } from "../../../themes/themes";
export const GeneralContainer = styled.div`
  position: relative;
  height: 100%;
  padding: 5px 0px 0px 10px;
  background-color: white;
  .inline-hr {
    width: 100%;
    margin-top: 8px;
    border: 1px solid ${({ theme }) => theme.neutral.gray[2600]};
  }
`;

export const Header = styled.div`
  width: 100%;
  height: 60px;
  background: linear-gradient(90deg, ${({ theme }) => theme.primary.purple} 10.12%, ${({ theme }) => theme.primary.purple} 88.5%);
  display: inline-block;
`;
export const MoodMeterLogo = styled.div`
  background: ${({ theme }) => theme.neutral.white};
  border-radius: 50px;
  display: flex;
  justify-content: center;
  width: 90px;
  height: 90px;
  align-items: center;
  position: absolute;
  top: -10px;
  left: -1px;
`;

export const MoodMeterText = styled.div`
  padding-left: 90px;
  height: 100%;
  display: flex;
  align-items: center;

  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 25px;

  color: ${({ theme }) => theme.neutral.white};
`;

export const SmileysContainer = styled.div`
  border: 1px solid #989898;
  border-radius: 10px;
  height: 18rem;
  overflow: hidden;
  margin: 0 5%;
`;

export const UsersContainer = styled.div`
  border: 1px solid #989898;
  border-radius: 10px;
  height: auto;
  margin: 1rem 5%;
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }
  ::-webkit-scrollbar {
    width: 8px;
    background-color: #f5f5f5;
  }
  ::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #b1b1b1;
  }
`;

export const TimeContainer = styled.div`
  border: 1px solid #989898;
  border-radius: 10px;
  height: 9rem;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0 5%;
`;

export const ReasonDetailContainer = styled.div`
  border: 1px solid #989898;
  border-radius: 10px;
  height: 22rem;
  overflow: auto;
  margin: 1rem 5%;
  #select-multiple-native {
    padding: 10px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: end;
  margin-right: 3.2em;
`;

export const ContentSelect = styled.div`
  .Mui-checked {
    color: ${({ theme }) => theme.button.primary} !important;
  }
  select option {
    margin: 0.135rem 0rem;
  }
  .css-26l3qy-menu {
    z-index: 2;
  }
  .MuiSelect-root {
    padding-top: 0.5rem;
  }
  .number-dropdown > .css-26l3qy-menu,
  .number-dropdown > .css-26l3qy-menu > div {
    max-height: 8rem;
    max-width: 4rem;
  }
  .align-center {
    align-items: center;
  }
  .select-placeholder {
    margin: 0 10px;
  }
  ul {
    padding: 5px;
    .remove-icon {
      display: flex;
      justify-content: flex-end;
    }
  }
  .number-dropdown {
    width: 100%;
  }

  .col-md-5.col-3 {
    flex: 0 0 45%;
    max-width: 45%;
    padding: 0;
  }
  .col-md-2.col-1 {
    flex: 0 0 10%;
    max-width: 10%;
  }

  .col-md-5.col-3 > div {
    width: 100%;
    max-width: 600px;
  }
`;

export const Title = styled.h6`
  font-weight: 600;
  text-align: center;
  color: ${({ theme }) => theme.primary.purple};
`;

export const SendSettings = styled.button`
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  float: right;
  height: 40px;
  text-align: center;
  color: white;
  opacity: ${({ ready }) => (ready ? 1 : 0.5)};
  &:hover {
    opacity: ${({ ready }) => (ready ? 0.9 : "")};
  }
`;

export const CancelSettings = styled.button`
  border: 1px solid ${({ theme }) => theme.primary.purple};
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  border-radius: 4px;
  height: 40px;
  text-align: center;
  color: ${({ theme }) => theme.button.primary};
  float: right;
  font-size: 14px;
  font-weight: 500;
  &:hover {
    opacity: 0.9;
  }
`;

export const TextTitleList = styled.p`
  color: ${({ theme }) => theme.neutral.gray[2600]};
  font-size: 18px;
`;

export const SelectStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    boxShadow: isFocused ? "#ffbbdc33" : theme.neutral.gray[700],
    borderColor: theme.neutral.gray[700],
    ":hover": {
      ...styles[":hover"],
      borderColor: "#ffbbdc33",
    },
  }),
  option: (styles, { data, isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#ffbbdc33" : data.color,
      ":hover": {
        ...styles[":hover"],
        backgroundColor: "#ffbbdc33",
      },
      color: isFocused ? theme.button.primary : data.color,
    };
  },
};

export const ContentButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-top: 0.1em;
`;

export const ButtonLink = styled.a`
  text-transform: "capitalize";
  cursor: pointer;
  color: ${({ theme }) => theme.button.primary};
  :hover {
    color: ${({ theme }) => theme.button.primary};
    text-decoration: "underline";
  }
`;

export const ContentModalAdd = styled.div`
  position: absolute;
  left: 35.2%;
  right: 35.2%;
  top: 25.64%;
  bottom: 75.77%;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  height: fit-content;
  width: auto;
`;

export const TextModalAdd = styled.div`
  padding: 1em;
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  text-align: left;
  font-weight: 600;
  font-size: 16px;
  height: 3.5em;
  &::-webkit-scrollbar {
    width: 0.3em;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[1000]};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;

export const ButtonAdd = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  margin: 1em auto;
  color: white;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover {
    background-color: rgba(46, 46, 46, 1);
  }
`;

export const ButtonAddCancel = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: white;
  border-radius: 4px;
  border: 1px solid;
  margin: 1em auto;
  color: ${({ theme }) => theme.button.primary};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
`;
